/* ============ AERIS — comportements ============ */

/* Popup newsletter */
(function(){
  var overlay=document.getElementById('nlOverlay');
  var closeBtn=document.getElementById('nlClose');
  var KEY='aeris_newsletter_closed';
  if(!overlay||!closeBtn)return;
  function openPopup(){ try{ if(localStorage.getItem(KEY)==='1')return; }catch(e){} overlay.classList.add('show'); }
  function closePopup(){ overlay.classList.remove('show'); try{ localStorage.setItem(KEY,'1'); }catch(e){} }
  window.setTimeout(openPopup,20000);
  closeBtn.addEventListener('click',closePopup);
  overlay.addEventListener('click',function(e){ if(e.target===overlay) closePopup(); });
})();

/* Menu Collections — clic uniquement */
(function(){
  var t=document.querySelector('.menu-toggle'), m=document.getElementById('AerisMegaMenu');
  if(!t||!m)return;
  function op(){m.hidden=false;t.setAttribute('aria-expanded','true');}
  function cl(){m.hidden=true;t.setAttribute('aria-expanded','false');}
  t.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();m.hidden?op():cl();});
  document.addEventListener('click',function(e){ if(!m.hidden&&!m.contains(e.target)&&e.target!==t)cl(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape')cl(); });
})();

/* Burger mobile */
(function(){
  var b=document.getElementById('AerisBurger'), p=document.getElementById('AerisMobileNav');
  if(!b||!p)return;
  b.addEventListener('click',function(e){
    e.stopPropagation();
    var o=!p.hidden; p.hidden=o;
    b.setAttribute('aria-expanded',o?'false':'true');
    b.setAttribute('aria-label',o?'Ouvrir le menu':'Fermer le menu');
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!p.hidden){p.hidden=true;b.setAttribute('aria-expanded','false');} });
})();

/* ---------- Confirmation d'ajout (panneau lateral) ---------- */
var AerisCart=(function(){
  var dr=document.getElementById('AerisDrawer'),
      bg=document.getElementById('AerisDrawerBg'),
      body=document.getElementById('AerisDrawerBody'),
      foot=document.getElementById('AerisDrawerFoot'),
      tot=document.getElementById('AerisDrawerTotal'),
      cnt=document.getElementById('AerisCartCount');

  function money(c){ return (c/100).toFixed(2).replace('.',',')+' €'; }
  function open(){ if(!dr)return; dr.classList.add('open'); dr.setAttribute('aria-hidden','false'); if(bg)bg.hidden=false; document.body.style.overflow='hidden'; }
  function close(){ if(!dr)return; dr.classList.remove('open'); dr.setAttribute('aria-hidden','true'); if(bg)bg.hidden=true; document.body.style.overflow=''; }

  function render(cart){
    if(cnt){ cnt.textContent=cart.item_count; cnt.hidden = cart.item_count===0; }
    if(!body)return;
    if(!cart.items.length){
      body.innerHTML='<p class="drawer-empty">Ton panier est vide.</p>';
      if(foot)foot.hidden=true; return;
    }
    var h='';
    cart.items.forEach(function(it){
      var img=it.image?it.image.replace(/(\.[a-z]+)(\?|$)/i,'_200x$1$2'):'';
      h+='<div class="dr-line">'+
         '<div class="dr-img">'+(img?'<img src="'+img+'" alt="">':'')+'</div>'+
         '<div class="dr-info"><a href="'+it.url+'">'+it.product_title+'</a>'+
         (it.variant_title&&it.variant_title.indexOf('Default')<0?'<em>'+it.variant_title+'</em>':'')+
         '<div class="dr-qty">'+
           '<button type="button" class="qbtn" data-key="'+it.key+'" data-q="'+(it.quantity-1)+'">−</button>'+
           '<span>'+it.quantity+'</span>'+
           '<button type="button" class="qbtn" data-key="'+it.key+'" data-q="'+(it.quantity+1)+'">+</button>'+
         '</div></div>'+
         '<div class="dr-price">'+money(it.final_line_price)+'</div>'+
         '</div>';
    });
    body.innerHTML=h;
    if(foot)foot.hidden=false;
    if(tot)tot.textContent=money(cart.total_price);
    body.querySelectorAll('.qbtn').forEach(function(b){
      b.addEventListener('click',function(){ change(b.dataset.key, parseInt(b.dataset.q,10)); });
    });
  }

  function refresh(cb){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();}).then(function(c){ render(c); if(cb)cb(); }).catch(function(){});
  }
  function change(key,q){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:Math.max(0,q)})})
      .then(function(r){return r.json();}).then(render).catch(function(){});
  }
  function add(form,btn,txt){
    var fd=new FormData(form);
    if(btn)btn.disabled=true;
    if(txt)txt.textContent='Ajout en cours…';
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:fd})
      .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
      .then(function(){ refresh(open); if(txt)txt.textContent='Ajouté ✓'; })
      .catch(function(){ if(txt)txt.textContent='Indisponible'; })
      .then(function(){ window.setTimeout(function(){ if(btn)btn.disabled=false; if(txt)txt.textContent='Ajouter au panier'; },1500); });
  }

  if(bg)bg.addEventListener('click',close);
  var cb=document.getElementById('AerisDrawerClose');
  if(cb)cb.addEventListener('click',close);
  var keep=document.getElementById('AerisKeep');
  if(keep)keep.addEventListener('click',close);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape')close(); });

  return {open:open,close:close,add:add,refresh:refresh};
})();

/* ---------- Page produit ---------- */
(function(){
  var sel=document.getElementById('AerisVariant');
  if(!sel)return;
  var hid=document.getElementById('AerisVariantId'),
      price=document.getElementById('AerisPrice'),
      split=document.querySelector('.price-split'),
      clab=document.getElementById('AerisColorLabel'),
      sws=document.querySelectorAll('#AerisSwatches .sw'),
      sizes=document.querySelectorAll('#AerisSizes .size-btn'),
      addBtn=document.getElementById('AerisAdd'),
      addTxt=document.getElementById('AerisAddTxt'),
      mainImg=document.getElementById('AerisMainImg'),
      form=document.getElementById('AerisProductForm');

  function opts(){ return Array.prototype.slice.call(sel.options); }
  function curColor(){ var a=document.querySelector('#AerisSwatches .sw.is-active'); return a?a.dataset.color:opts()[0].dataset.color; }
  function curSize(){ var a=document.querySelector('#AerisSizes .size-btn.is-active'); return a?a.dataset.size:null; }

  function apply(){
    var c=curColor(), s=curSize(), found=null;
    opts().forEach(function(o){ if(o.dataset.color===c && (!s||o.dataset.size===s) && !found) found=o; });
    if(!found)return;
    sel.value=found.value;
    if(hid)hid.value=found.value;
    if(price)price.textContent=found.dataset.price;
    if(split)split.textContent='ou 3x '+found.dataset.split+' sans frais';
    if(clab)clab.textContent=found.dataset.color;
    var ok=found.dataset.available==='true';
    if(addBtn)addBtn.disabled=!ok;
    if(addTxt)addTxt.textContent= ok?'Ajouter au panier':'Épuisé dans cette taille';
  }
  function refreshSizes(){
    var c=curColor();
    sizes.forEach(function(b){
      var avail=false;
      opts().forEach(function(o){ if(o.dataset.color===c&&o.dataset.size===b.dataset.size&&o.dataset.available==='true')avail=true; });
      b.classList.toggle('is-out',!avail);
    });
  }

  /* ---------- Filtrage des vignettes par couleur ----------
     On n'affiche que les vignettes de la couleur active.
     Sans pastille ou sans couleur (ex. T-shirt Shadows), toutes
     les vignettes restent visibles.
     01/11/2026 : si aucune vignette ne correspond a la couleur
     (photos sans couleur reconnue), on les affiche toutes au lieu
     de tout masquer, sinon le zoom n'avait plus rien a montrer. */
  var allThumbs=Array.prototype.slice.call(document.querySelectorAll('#AerisThumbs .thumb'));
  function filterThumbs(color){
    if(!allThumbs.length)return;
    if(!sws.length || !color){
      allThumbs.forEach(function(t){ t.style.display=''; });
      return;
    }
    var matches=allThumbs.filter(function(t){ var tc=t.getAttribute('data-color')||''; return tc!=='' && tc===color; });
    if(!matches.length){
      allThumbs.forEach(function(t){ t.style.display=''; });
      return;
    }
    allThumbs.forEach(function(t){
      t.style.display = matches.indexOf(t)>-1 ? '' : 'none';
      t.classList.remove('is-active');
    });
    matches[0].classList.add('is-active');
    if(mainImg){ mainImg.src=matches[0].dataset.full; mainImg.dataset.zoom=matches[0].dataset.zoom; }
  }

  sws.forEach(function(b){
    b.addEventListener('click',function(){
      sws.forEach(function(x){x.classList.remove('is-active');});
      b.classList.add('is-active');
      if(clab)clab.textContent=b.dataset.color;
      filterThumbs(b.dataset.color);
      refreshSizes(); apply();
    });
  });
  sizes.forEach(function(b){
    b.addEventListener('click',function(){
      sizes.forEach(function(x){x.classList.remove('is-active');});
      b.classList.add('is-active'); apply();
    });
  });

  if(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      if(!curSize()&&sizes.length){
        var blk=document.getElementById('AerisSizes');
        if(blk){ blk.classList.add('shake'); window.setTimeout(function(){blk.classList.remove('shake');},520); }
        if(addTxt)addTxt.textContent='Choisis ta taille';
        window.setTimeout(function(){ if(addTxt)addTxt.textContent='Ajouter au panier'; },1700);
        return;
      }
      AerisCart.add(form,addBtn,addTxt);
    });
  }
  refreshSizes(); apply();
  filterThumbs(curColor());

  /* ---------- Galerie et zoom ----------
     01/11/2026 : le zoom s'ouvre sur la photo affichee (et plus
     toujours sur la premiere), on peut defiler avec les fleches,
     le clavier ou le doigt, et il marche aussi s'il n'y a qu'une
     photo ou aucune vignette. */
  var thumbs=allThumbs;
  var mainBtn=document.getElementById('AerisMainBtn');
  var ov=document.getElementById('AerisZoom'), zi=document.getElementById('AerisZoomImg'),
      zc=document.getElementById('AerisZoomClose'), zp=document.getElementById('AerisZoomPrev'),
      zn=document.getElementById('AerisZoomNext'), ct=document.getElementById('AerisZoomCount');
  var cur=0;
  function visibleThumbs(){ return thumbs.filter(function(t){ return t.style.display!=='none'; }); }
  thumbs.forEach(function(t){
    t.addEventListener('click',function(){
      thumbs.forEach(function(x){x.classList.remove('is-active');});
      t.classList.add('is-active');
      if(mainImg){ mainImg.src=t.dataset.full; mainImg.dataset.zoom=t.dataset.zoom; }
    });
  });
  function show(i){
    var vis=visibleThumbs();
    if(!vis.length){
      if(zi&&mainImg){ zi.src=mainImg.dataset.zoom||mainImg.src; zi.alt=mainImg.alt||''; }
      if(zp)zp.style.display='none'; if(zn)zn.style.display='none'; if(ct)ct.style.display='none';
      return;
    }
    var n=vis.length;
    cur=((i%n)+n)%n;
    zi.src=vis[cur].dataset.zoom;
    var im=vis[cur].querySelector('img'); zi.alt=im?im.alt:'';
    if(ct)ct.textContent=(cur+1)+' / '+n;
    var solo=n<2;
    if(zp)zp.style.display=solo?'none':'';
    if(zn)zn.style.display=solo?'none':'';
    if(ct)ct.style.display=solo?'none':'';
  }
  function openZoom(){
    if(!ov||!zi)return;
    var vis=visibleThumbs();
    var start=0;
    vis.forEach(function(t,k){ if(t.classList.contains('is-active'))start=k; });
    show(start);
    ov.hidden=false;
    document.body.style.overflow='hidden';
  }
  if(mainBtn&&ov&&zi){
    mainBtn.addEventListener('click',function(e){ e.preventDefault(); openZoom(); });
    var zclose=function(){ ov.hidden=true; zi.src=''; document.body.style.overflow=''; };
    if(zc)zc.addEventListener('click',function(e){ e.stopPropagation(); zclose(); });
    if(zp)zp.addEventListener('click',function(e){e.stopPropagation();show(cur-1);});
    if(zn)zn.addEventListener('click',function(e){e.stopPropagation();show(cur+1);});
    ov.addEventListener('click',function(e){ if(e.target===ov)zclose(); });
    document.addEventListener('keydown',function(e){
      if(ov.hidden)return;
      if(e.key==='Escape')zclose();
      if(e.key==='ArrowLeft')show(cur-1);
      if(e.key==='ArrowRight')show(cur+1);
    });
    var x0=null;
    ov.addEventListener('touchstart',function(e){x0=e.changedTouches[0].clientX;},{passive:true});
    ov.addEventListener('touchend',function(e){
      if(x0===null)return;
      var d=e.changedTouches[0].clientX-x0;
      if(Math.abs(d)>45)show(d<0?cur+1:cur-1);
      x0=null;
    },{passive:true});
  }
})();
